import { Container, Row, Col, Tab, Nav } from "react-bootstrap";

import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png";
import checkMark from "../assets/img/icons8-checkmark.svg";
export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Skills</h2>
              <p></p>
              <Container>
                <Row>
                  <Col md={4} xs={6}>
                    <div className="skill-item">
                      <img
                        src={checkMark}
                        alt="Image"
                      />
                      <h5>Javascript</h5>
                    </div>
                  </Col>
                  <Col md={4} xs={6}>
                    <div className="skill-item">
                      <img src={checkMark} alt="Image" />
                      <h5>React/Next.js</h5>
                    </div>
                  </Col>
                  <Col md={4} xs={6}>
                    <div className="skill-item">
                      <img src={checkMark} alt="Image" />
                      <h5>Redux/Context</h5>
                    </div>
                  </Col>
                </Row>
                <Row style={{marginTop:'8px'}}>
                  <Col md={4} xs={6}>
                    <div className="skill-item">
                      <img
                        src={checkMark}
                        alt="Image"
                      />
                      <h5>Node.js / Express.js</h5>
                    </div>
                  </Col>
                  <Col md={4} xs={6}>
                    <div className="skill-item">
                      <img src={checkMark} alt="Image" />
                      <h5>Solidity</h5>
                    </div>
                  </Col>
                  <Col md={4} xs={6}>
                    <div className="skill-item">
                      <img src={checkMark} alt="Image" />
                      <h5>Tailwind / Material Ui</h5>
                    </div>
                  </Col>
                </Row>
                <Row style={{marginTop:'8px'}}>
                  <Col md={4} xs={6}>
                    <div className="skill-item">
                      <img src={checkMark} alt="Image" />
                      <h5>Docker</h5>
                    </div>
                  </Col>
                  <Col md={4} xs={6}>
                    <div className="skill-item">
                      <img src={checkMark} alt="Image" />
                      <h5>Python / flask</h5>
                    </div>
                  </Col>
                  <Col md={4} xs={6}>
                    <div className="skill-item">
                      <img src={checkMark} alt="Image" />
                      <h5>LLMs</h5>
                    </div>
                  </Col>

                </Row>

              </Container>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  );
};

